var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RatioBox',{attrs:{"ratio":1}},[_c('QrCode',_vm._b({ref:"qrCode",staticClass:"qr-code",attrs:{"data":_vm.qrUrl,"image":_vm.imageSrc}},'QrCode',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }